module.exports = __webpack_public_path__ + "img/sell.f0f4a2c7.svg";